
import type { ActionType, ProColumns } from '@ant-design/pro-components';
import {
  ProTable,
  ProFormInstance
} from '@ant-design/pro-components';
import { Modal } from 'antd';
import { useEffect, useRef } from 'react' 
type ProSelectTableProps = {
  dataSource: (value: any) => Promise<any>
  columns: ProColumns []
  open: boolean
  onCancel: (values?: any) => void;
  width?: number;
  fieldProps?: any;
  selectRow?: any;
  key?: string;
  setSelectRow?: any;
}
export const ProSelectTable = (props: ProSelectTableProps) => {
  const actionRef = useRef<ActionType>();
  const formRef = useRef<ProFormInstance>();
  
  useEffect(() => {
    if (props.open) {
      actionRef.current?.reload()
    }
  }, [props.open])
  return (
    <Modal
      width={props.width || 600}
      open={props.open}
      onCancel={props.onCancel}
      closable={false}
      footer={null}
    >
      <ProTable
        scroll={{ x: 'max-content' }}
        rowKey={props.key || 'id'}
        formRef={formRef}
        actionRef={actionRef}
        columns={props.columns}
        rowSelection={{
          selectedRowKeys: props.selectRow,
          onChange: (_, selectedRows) => {
            const ids = selectedRows.map(item => item.id)
            props.setSelectRow(ids)
          },
        }}
        request={async (params: any) => {
          params.pageNum = params.current
          delete params.current
          const res = await props.dataSource(params)
          return {
            data: res?.list,
            total: res?.total,
            success: true
          }
        }}
        {...props.fieldProps}
      >
        
      </ProTable>
    </Modal>
  )
}